"use strict";

require("core-js/modules/es.object.assign.js");

require("core-js/modules/web.dom-collections.iterator.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FAEUserInfoTabs = void 0;

var _react = _interopRequireWildcard(require("react"));

var _FAEText = require("../FAEText/FAEText");

require("./FAEUserInfoTabs.scss");

const _excluded = ["className", "tabs", "renderOption", "activeTab"],
      _excluded2 = ["label", "href", "className"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

const FAEUserInfoTabs = _ref => {
  let {
    className = "",
    tabs = [],
    renderOption,
    activeTab = ""
  } = _ref,
      rest = _objectWithoutProperties(_ref, _excluded);

  const selectedTab = value => {
    return value.toLowerCase() === activeTab.toLowerCase() ? "active-tab" : "";
  };

  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", _extends({
    className: "fae--user-info-tabs-main-container ".concat(className)
  }, rest), _react.Children.toArray(tabs.map((tab, index) => {
    const {
      label,
      href = "",
      className
    } = tab,
          rest = _objectWithoutProperties(tab, _excluded2);

    return href === "" ? /*#__PURE__*/_react.default.createElement(_FAEText.FAEText, _extends({
      tertiary: selectedTab(label) === "active-tab" ? false : true
    }, rest, {
      className: "fae--user-info-tab ".concat(selectedTab(label), " ").concat(className)
    }), renderOption ? renderOption(tab) : label) : /*#__PURE__*/_react.default.createElement("a", _extends({
      className: "fae--user-info-tab ".concat(className),
      target: "_blank",
      href: href,
      rel: "noreferrer"
    }, rest), /*#__PURE__*/_react.default.createElement(_FAEText.FAEText, null, renderOption ? renderOption(tab) : label));
  }))));
};

exports.FAEUserInfoTabs = FAEUserInfoTabs;